import GameTabs from './GameTabs';

export default GameTabs;
